import { t as r } from "../internals/typed-array-constructors-require-wrappers.js";
import { a } from "../internals/array-buffer-view-core.js";
import { t } from "../internals/typed-array-from.js";
(0, a.exportTypedArrayStaticMethod)("from", t, r);